import { Navigate, Route, Routes } from "react-router-dom";
import { useProfiles } from "../lib/profiles.js";
import Dashboard from "./Dashboard.js";
import Transactions from "./Transactions.js";
import Login from "./Login.js";
import SellRequest from "./SellRequest.js";
import Purchase from "./Purchase.js";
import TreasuryProfile from "./TreasuryProfile.js";
import SendTDN from "./PurchaseCreate.js";

function WithActiveProfile({ children }) {
  let { active } = useProfiles();
  if (!active) {
    return <Navigate to="/login" />;
  }
  return <>{children}</>;
}

export default function AppRoutes() {
  return <Routes>

    <Route path="/" element={<Navigate to="/home"/>} />
    <Route path="/login" element={<Login />} />
    {/* <Route path="/logout" element={<Logout/>} /> */}

    {/* route aliases for devx */}
    <Route path="/home" element={<Navigate to="/dashboard" />} />
    <Route path="/dash" element={<Navigate to="/dashboard" />} />
    <Route path="/txs" element={<Navigate to="/transactions" />} />
    <Route path="/snd" element={<Navigate to="/purchase/create" />} />

    <Route path="/dashboard" element={<WithActiveProfile><Dashboard /></WithActiveProfile>} />
    <Route path="/transactions" element={<WithActiveProfile><Transactions /></WithActiveProfile>} />
    <Route path="/sell-request/:id" element={<WithActiveProfile><SellRequest /></WithActiveProfile>} />
    <Route path="/profile/:url" element={<WithActiveProfile><TreasuryProfile /></WithActiveProfile>} />
    <Route path="/purchase/create" element={<WithActiveProfile><SendTDN /></WithActiveProfile>}/>
    <Route path="/purchase/:id" element={<WithActiveProfile><Purchase /></WithActiveProfile>} />
  </Routes>

}
